// extracted by mini-css-extract-plugin
export var articleQuote = "News-module--articleQuote--e2cb5";
export var container = "News-module--container--469ed";
export var decor = "News-module--decor--74d7c";
export var link = "News-module--link--2e812";
export var logo = "News-module--logo--b4f18";
export var logoList = "News-module--logoList--8d568";
export var newsSources = "News-module--newsSources--3612d";
export var relativeWrapper = "News-module--relativeWrapper--7fbb5";
export var tag = "News-module--tag--11784";